<search-input-row placeholderText="Search determinant"
                    (onAdd)="openAddModal()"
                    (onSearchVarUpdate)="determinantsFilter.name = $event"
                    [roundedCorners]="true"
                    [bottomSpacing]="false"></search-input-row>
<div class="row mb-3" *ngIf="loading">
    <div class="col text-center">
        <i class="fad fa-spinner-third fa-spin"></i>
    </div>
</div>
<div class="rows-list row no-gutters determinants" *ngIf="!loading"
        cdkDropList
        id="{{prefix}}-conditionsList"
        [cdkDropListConnectedTo]="connectedTo"
    [cdkDropListData]="conditions | filterBy: determinantsFilter"
    (cdkDropListDropped)="dropped($event)">
    <div cdkDrag class="nglist-item col-12"
            *ngFor="let cond of conditions | filterBy: determinantsFilter">
        <div class="nglist-item-content flex-grow-1 pr-0" (click)="editDeterminant(cond)">
            <i class="fad status-icon fa-circle-dot {{cond.status ? 'text-success' : 'text-danger'}} mr-2" tooltip="{{(cond.status ? 'Valid determinant' : 'Incomplete determinant') | translate}}"></i>
            <span class="list-group-item-text text-left">{{cond.name}}</span>
            <i *ngIf="cond.isDuplicate" class="fad fa-clone text-warning mr-2 ml-auto d-inline-block" position="left" [tooltip]="'Duplicate of: ' + (cond.duplicateNames?.join(', ') || 'Unknown')"></i>
        </div>
        <div *ngIf="cond.loading" class="ml-auto mr-2">
            <i class="fad fa-spinner-third fa-spin"></i>
        </div>
        <span *ngIf="cond && cond.determinantType && !cond.loading" class="badge badge-default badge-letter mr-2 ml-auto" tooltip="{{cond.determinantType}}">{{ cond.determinantType[0]}}</span>
        <!--<span *ngIf="addDeterminantTo != null && !cond.loading" class="nglist-item-actions text-right" class="btn btn-sm btn-default mr-2"
                (click)="addDeterminantTo(cond)">{{'Select' | translate}}</span>-->
    </div>
</div>
